import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { VhQueryAutoWeb, VhEventMediator } from 'vhautowebdb';
import { isPlatformBrowser } from '@angular/common';
import { PLATFORM_ID, Inject } from '@angular/core';
import { AtwUpdateDbComponent } from 'vhobjects-service';
import { FunctionService  } from 'vhobjects-service';

@Component({
  selector: 'atw-frame-product-detail-admin-config',
  templateUrl: './frame-product-detail-admin-config.component.html',
  styleUrls: ['./frame-product-detail-admin-config.component.scss']
})
export class AtwFrameProductDetailAdminConfig extends AtwUpdateDbComponent implements OnInit {
  @Input() objectChoosing: any; // lấy giá trị data trả vể từ page
   @Input() device: any; // xác định device là desktop hay mobile
   @Input() class: any; // là dữ liệu desktop_class hoặc mobile_class từ database
   @Input() config: any;@Input() type: any; // là dữ liệu desktop_config hoặc mobile_config từ database
   @Input() staticdata: any; // là dữ liệu staticdata từ database
   @Output() changeOptionConfig = new EventEmitter<any>();
   isViewAll: boolean = false;

   public borderWidth = {
     top: 0,
     right: 0,
     bottom: 0,
     left: 0,
   };
   public borderRadius = 0; // Giá trị border-radius của frame
   public urlBackgroundImage = ''; // Giá trị đường dẫn của background-image
   public loadComplete = false;
   public openMenu: { [name: string]: boolean } = {
     menu1: true,
     menu2: false,
   };
   public currentViewAll: any = {};
   public stylesField = [
     {
       title: 'dieu_chinh_vien_khung',
       index: 1,
     },
   ];
   configMode: 'basic' | 'advanced' = 'basic';
   constructor(
      public vhQueryAutoWeb: VhQueryAutoWeb, 
      public vhEventMediator: VhEventMediator,
      @Inject(PLATFORM_ID) private platformId: Object,
      public functionService: FunctionService
   ) {
      super(vhQueryAutoWeb, vhEventMediator, functionService);
    }
   ngOnInit(): void {
    if (!this.config['box-shadow'])
      this.config["box-shadow"] = {
        "is_box_shadow": false,
        "property_box_shadow": {
          "type": "outset",
          "h-offset": 1,
          "v-offset": 1,
          "blur": 1,
          "spread": 1,
          "color": "#ffffffff"
        }
      };
     if (isPlatformBrowser(this.platformId))
       this.initData();
   }
 
   openHandler(value: string): void {
     for (const key in this.openMenu) {
       if (key !== value) {
         this.openMenu[key] = false;
       }
     }
   }
 
   /** Hàm này thực hiện khởi tạo dữ liệu;
    *
    */
   initData() {
     if (this.config && this.class) {
       this.loadComplete = true;
     }
   }
 
   ngOnChanges(changes: SimpleChanges): void {
     if (changes) {
       if (changes.data_config) {
         this.config = changes.data_config.currentValue;
         this.initData();
       }
       if (changes.device) this.device = changes.device.currentValue;
     }
   }
 
   /**
    * Hàm này dùng để mở rộng phần cấu hình.
    * @param field_text : trả về phần tử được chọn của mảng style_field
    */
   openViewAll(field_text) {
     this.currentViewAll = field_text;
     this.isViewAll = !this.isViewAll;
   }
  //  //Hàm update class
  //  updateClass() {
  //    this.vhQueryAutoWeb
  //      .updateObject(this.objectChoosing._id, {
  //        [this.device + '_class']: this.class,
  //      })
  //      .then((bool: any) => {
 
  //      });
  //  }
 
  //  //Hàm update class
  //  updateConfig() {
  //    this.vhQueryAutoWeb
  //      .updateObject(this.objectChoosing._id, {
  //        [this.device + '_config']: this.config,
  //      })
  //      .then((bool: any) => {
 
  //      });
  //  }
 
 
   handleChangeContainer(event: any) {
     this.config['frame-product-detail__boundary']['is_container'] = event;
     if (event) {
       this.class['frame-product-detail__boundary']['width'] = '75%';
       this.class['frame-product-detail__boundary']['position'] = 'relative';
     } else {
       this.class['frame-product-detail__boundary']['width'] = '100%';
       this.class['frame-product-detail__boundary']['position'] = 'unset';
     }
     this.updateClass();
     this.updateConfig();
   }
}
